/**
 * Configurazione per l'upload dei file
 */

import { MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB } from '@prospero/shared';

export { MAX_FILE_SIZE_MB };

/**
 * Verifica se un file supera la dimensione massima consentita
 * @param file - Il file da verificare
 * @returns true se il file è troppo grande
 */
export function isFileTooLarge(file: File): boolean {
  return file.size > MAX_FILE_SIZE_BYTES;
}

/**
 * Formatta la dimensione del file in modo leggibile
 * @param bytes - Dimensione in bytes
 * @returns Stringa formattata (es. "5.2 MB")
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
